import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'esTabModel',
  props: [ 'active', 'hide'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (!__props.hide)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["estab", (__props.active === 'true') ? 'active' : '']),
        ref: "esTabsModel"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
    : _createCommentVNode("", true)
}
}

})